var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearch = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18v18H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#348CFD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.565,
  cy: 5.565,
  r: 5.565
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 9.5 16 16"
})))));
export { SvgIconSearch as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-search.svg";